import Menu from "./Menu/Routes";
import Role from "./Role/Route";

export default [...Menu, ...Role];
